export enum RoutePermissions {
    HasApi = 'has_api',
    CertificateSection = 'certificate_section',
    SubscriptionSection = 'subscription_section',
    IsAdmin = 'is_admin',
    ShowGauges = 'show_gauges',
    ShowNewTemplates = 'show_new_templates',
    ShowLegacyTemplates = 'show_legacy_templates',
    ShowHomeSection = 'show_home_section',
    Reseller = 'reseller',
    ShowNewSettings = 'show_new_micro_settings',
    ShowLegacySettings = 'show_legacy_micro_settings',
}
